const $ = jQuery.noConflict();

// --------------------------------------------------------------------------
// Cache DOM

const $html = $('html');
const $body = $('body');

let scrollTop;

// --------------------------------------------------------------------------
// Functions

export const ScreenLock = {
    lock() {
        const $window = $(window);
        const windowHeight = $window.height();

        scrollTop = $window.scrollTop();

        $html.css({
            height: windowHeight,
            overflow: 'hidden',
        });

        $body.css({
            height: `${windowHeight + scrollTop}px`,
            overflow: 'hidden',
            marginTop: `-${scrollTop}px`,
        });
    },

    unlock() {
        const $window = $(window);
        $html.add($body).attr('style', '');
        $window.scrollTop(scrollTop);
    },

    relock() {
        $html.add($body).attr('style', '');
    }
};
